import { Check } from "lucide-react";
import { TRUST_ITEMS, MARQUEE_WORDS } from "../../data/content";

export const TrustBar = () => {
  const loop = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <section className="relative z-20 -mt-2" aria-label="Why clients trust Ffyona">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="rounded-3xl bg-white shadow-soft border border-sage-light/40 px-6 py-7 lg:px-10 lg:py-8">
          <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-6 gap-y-4">
            {TRUST_ITEMS.map((item) => (
              <li key={item} className="flex items-start gap-2.5" data-testid="trust-item">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage-light">
                  <Check size={13} strokeWidth={2.5} className="text-sage-dark" />
                </span>
                <span className="text-sm text-ink-soft leading-snug">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-16 lg:mt-20 border-y border-sage-light/50 bg-cream-100/60 py-6 overflow-hidden">
        <div className="marquee-track flex w-max items-center gap-8 whitespace-nowrap">
          {loop.map((w, i) => (
            <span key={i} className="mx-4 font-serif text-3xl lg:text-4xl italic text-sage flex items-center gap-8">
              {w}
              <span className="text-warm/60 not-italic text-xl">✦</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
